<!-- 报表 采购退货出库单 详情-->
<template>
  <div id="stockdetail">
    <el-row>
      <el-col :span="12">
        <ul>
          <li>供应商名称：{{ titleData.VENDOR_NAME }}</li>
          <li>订单编号：{{ titleData.ORDER_CODE }}</li>
        </ul>
      </el-col>
      <el-col :span="12">
        <ul>
          <li>退货日期：{{ titleData.RETURN_DAY }}</li>
          <li>退货总金额：{{ totalFee }}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" stripe border style="width: 100%">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="PRODUCT_PRICE" label="单价"></el-table-column>
          <el-table-column prop="GYSCATALOGNAME" label="分类"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="退货数量"></el-table-column>
          <el-table-column prop="PRODUCT_FEE" label="退货金额"></el-table-column>
          <el-table-column prop="RETURN_REASON" label="备注"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="margin-top: 20px">
        <el-button @click="toPrintTable">打印退货出库单</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { getPurchaseReturnStockOutDetailFun } from 'api/returnWare';
import { print } from 'api/warehouseManager';

export default {
  data() {
    return {
      tableData: [],
      titleData: {},
      totalFee: '',
      companyName: '',
      name: '',
      WHERE: Number(sessionStorage.getItem('where')),
    };
  },
  created() {
    this.companyName = sessionStorage.getItem('company');
    this.name = sessionStorage.getItem('name');
    this.getRecordDetail();
  },
  methods: {
    // ----------------------拉取数据
    getRecordDetail() {
      this.titleData = JSON.parse(sessionStorage.getItem('returnMess'));
      const params = {
        RETURN_ORDER_ID: Number(sessionStorage.getItem('RETURN_ID')),
      };
      getPurchaseReturnStockOutDetailFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.tableData = result;
            this.totalFee = result.reduce((totalPrice, item) => totalPrice + Number(item.PRODUCT_FEE), 0);
          } else {
            this.tableData = [];
            this.totalFee = 0;
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    toPrintTable() {
      let html = '<div>';
      html += '<div class="main">';
      html += `<div class="title">${this.companyName}采购退货出库单</div>`;
      html += `<div class="head"><div class="code" style="font-size: 20px;">供应商：${this.titleData.VENDOR_NAME}</div><div style="font-size: 20px;">日期：${this.titleData.RETURN_DAY}</div></div>`;
      html += `<div class="head"><div class="code" style="font-size: 20px;">盘库单编号：${this.titleData.ORDER_CODE}</div><div style="font-size: 20px;">总金额：${this.totalFee}</div></div>`;
      html += '<table border="1" cellspacing="0"><div class="el-table__body el-table__header">';
      html += '<tr style="font-size: 16px;"><th style="width: 50px">序号</th> <th>产品</th> <th>单位</th> <th  style="width: 40px">单价</th> <th style="width: 70px">退货数量</th> <th  style="width: 70px">退货金额</th> <th>备注</th> </tr>';
      html += '</div><div class="el-table__body">';
      this.tableData.forEach((item, index) => {
        html += '<tr style="text-align: center; font-size: 20px;">';
        html += `<td> ${index + 1} </td> <td>${item.PRODUCT_NAME}</td> <td>${item.TYPE_UNIT}</td> <td>${item.PRODUCT_PRICE}</td>
                <td>${item.PRODUCT_COUNT}</td> <td>${item.PRODUCT_FEE}</td> <td>${item.RETURN_REASON}</td>`;
        html += '</tr>';
      });
      html += '</div>';
      html += '</table>';
      html += '</div>';
      html += `<div style="margin-top: 20px; display: flex; flex-direction: row; font-size: 20px;"><div>退货人：</div><div style="margin-left: 200px;font-size: 20px;">主管：</div><div style="margin-left: 200px;font-size: 20px;">制单人：${this.name}</div></div>`;
      html += '</div>';
      const windows = print(html);
      windows.close();
    },
  },
};
</script>
<style scoped>
.footer {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
}

ul {
  list-style: none;
  min-height: 5px;
  padding: 0;
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/tableManage/purchaseReturnStockOutDetail.vue